import { createContext } from 'react';
import { SurveyFormContextData } from '../domain/usecases';

export const SurveyFormContext = createContext<SurveyFormContextData>(
  {} as SurveyFormContextData,
);
